import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';
const REGISTRADO = 1;
const EMITIDO = 2;
const RECHAZADO = 3;
const ANULADO = 4;
export default function ResultList(props) {

    const renderColor = (row) => {
        if (row.idResumenEstado === REGISTRADO)
            return 'blue';
        if (row.idResumenEstado === EMITIDO)
            return 'green';
        if (row.idResumenEstado === RECHAZADO)
            return 'orange';
        if (row.idResumenEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title="Detalle Comprobantes">
                                <Button
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    loading={props.loadingVer}
                                    onClick={() => props.onView(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Anular">
                                <Button
                                    type="danger"
                                    icon="close"
                                    size={"small"}
                                    disabled={(row.idResumenEstado === REGISTRADO ? false : true)}
                                    onClick={() => props.onAnular(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="CDR">
                                <Button
                                    type="primary"
                                    icon="file-text"
                                    size={"small"}
                                    disabled={row.idResumenEstado == EMITIDO ? false : true}
                                    onClick={() => props.onCdr(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={"Consultar Ticket"}>
                                <Button
                                    disabled={row.flagTicketEnviado ? true : row.idResumenEstado === EMITIDO ? false : true}
                                    type="primary"
                                    icon="monitor"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onTicket(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Emitir">
                                <Button
                                    type="success"
                                    size={"small"}
                                    loading={props.loadingEmitir}
                                    style={{ paddingLeft: "4px", paddingRight: "4px" }}
                                    disabled={row.idResumenEstado === REGISTRADO ? false : true}

                                    onClick={() => props.onEmitir(row)}
                                >
                                    <img
                                        src={require(`../../../assets/images/send${row.idResumenEstado === REGISTRADO ? "" : "-block"}.png`)}
                                        style={{ height: "14px", marginBottom: '3px' }} alt="icon" />
                                </Button>
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Correlativo',
                    dataIndex: 'correlativo',
                    key: 'correlativo',
                    sorter: true
                },
                {
                    title: 'Fecha Documento',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Fecha Envio',
                    dataIndex: 'fechaEnvioStr',
                    key: 'fechaEnvioStr',
                    sorter: true
                },
                {
                    title: 'Total Comprobantes',
                    dataIndex: 'totalComprobantes',
                    key: 'totalComprobantes',
                    sorter: true
                },
                {
                    title: 'Ticket',
                    dataIndex: 'ticketResumenDiario',
                    key: 'ticketResumenDiario',
                    sorter: true
                },
                {
                    title: 'Observacion',
                    dataIndex: 'mensajeSunat',
                    key: 'mensajeSunat',
                    sorter: true
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreEstado',
                    key: 'nombreEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}